module.exports = __webpack_public_path__ + "img/men3-img.d7dd25a7.png";